import * as styles from "./triggerDisplayManager.module.scss";
export class TriggerDisplayManager {
    getHeaderClass() {
        return styles["trigger-display"];
    }
    shouldDisplayPortLabels() {
        return true;
    }
    getHeaderText(nodeData) {
        return nodeData.data.name;
    }
    getBackgroundColor() {
        return "";
    }
    updatePreviewContent(nodeData, contentArea) { }
}
//# sourceMappingURL=triggerDisplayManager.js.map